<template>
  <div>
    <widget
      :id="'client-addresses'"
      :title="$tc('words.address', 1)"
      :button="true"
      :button-text="$tc('phrases.newAddress')"
      color="primary"
      @widgetAction="addNewAddress"
      :paginator="addresses.paginator"
      :subscriber="subscriber"
    >
      <md-table
        style="width: 100%"
        v-model="addresses.list"
        md-card
        md-fixed-header
      >
        <md-table-row
          @click="editAddress(item, index)"
          slot="md-table-row"
          slot-scope="{ item, index }"
        >
          <md-table-cell :md-label="$tc('words.street')" md-sort-by="street">
            {{ item.street }}
          </md-table-cell>
          <md-table-cell :md-label="$tc('words.city')" md-sort-by="city">
            {{ item.city }}
          </md-table-cell>
          <md-table-cell :md-label="$tc('words.phone')" md-sort-by="phone">
            {{ item.phone }}
          </md-table-cell>
          <md-table-cell :md-label="$tc('words.primary')" md-sort-by="primary">
            <input
              type="checkbox"
              readonly
              :checked="item.primary"
              onclick="return false;"
            />
          </md-table-cell>
          <md-table-cell :md-label="$tc('words.actions')">
            <md-button
              v-if="!item.primary"
              class="md-icon-button md-dense md-accent"
              @click.stop="confirmDelete(item)"
            >
              <md-tooltip md-direction="top">
                {{ $tc("words.delete") }}
              </md-tooltip>
              <md-icon>delete_outline</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </widget>
    <md-dialog
      class="address-edit-container md-size-100"
      :md-active.sync="modalVisibility"
    >
      <md-dialog-title v-if="editFlag">
        {{ $tc("phrases.updateAddress") }}
      </md-dialog-title>
      <md-dialog-title v-if="!editFlag">
        {{ $tc("phrases.newAddress") }}
      </md-dialog-title>
      <md-dialog-content class="md-scrollbar">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <city-autocomplete v-model="newAddress.city_id" />
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field>
              <label for="Street">
                {{ $tc("words.street") }}
              </label>
              <md-input
                type="text"
                id="Street"
                name="Street"
                v-model="newAddress.street"
              />
            </md-field>
          </div>
        </div>

        <div class="md-layout md-gutter md-size-100">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field name="email">
              <label for="email">{{ $tc("words.email") }}</label>
              <md-input type="email" name="email" v-model="newAddress.email" />
            </md-field>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <template>
              <vue-tel-input
                name="phone"
                id="phone"
                :validCharactersOnly="true"
                mode="international"
                invalidMsg="invalid phone number"
                :disabledFetchingCountry="false"
                :disabledFormatting="false"
                placeholder="Enter a phone number"
                :required="true"
                :preferredCountries="['TZ', 'CM', 'KE', 'NG', 'UG']"
                autocomplete="off"
                enabledCountryCode="true"
                v-model="newAddress.phone"
                @validate="validatePhone"
                @input="onPhoneInput"
              ></vue-tel-input>
              <span
                v-if="!phone.valid && firstStepClicked"
                style="color: red"
                class="md-error"
              >
                invalid phone number
              </span>
            </template>
          </div>
        </div>

        <div class="md-layout md-size-100">
          <div class="md-layout-item md-size-100">
            <label>
              <input type="checkbox" v-model="newAddress.primary" />
              {{ $tc("words.primary") }}
            </label>
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-accent" @click="closeModal()">
          {{ $tc("words.close") }}
        </md-button>

        <md-button
          class="md-primary btn-lg"
          @click="saveAddress()"
          v-text="editFlag ? this.$tc('words.update') : this.$tc('words.save')"
        />
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import { notify } from "@/mixins/notify.js"
import { Address, Addresses } from "@/services/AddressService.js"
import CityAutocomplete from "@/shared/CityAutocomplete.vue"
import { EventBus } from "@/shared/eventbus.js"
import Widget from "@/shared/Widget.vue"

export default {
  name: "Addresses",
  components: { CityAutocomplete, Widget },
  mixins: [notify],
  props: {
    personId: Number,
  },
  data() {
    return {
      addresses: new Addresses(this.personId),
      subscriber: "personAddresses",
      modalVisibility: false,
      newAddress: { city_id: null },
      editFlag: false,
      addressIndex: 0,
      phone: {
        valid: true,
      },
    }
  },
  mounted() {
    EventBus.$on("pageLoaded", this.reloadList)
  },
  destroyed() {
    EventBus.$off("pageLoaded", this.reloadList)
  },
  methods: {
    reloadList(subscriber, data) {
      if (subscriber !== this.subscriber) return
      this.addresses.updateList(data)
      EventBus.$emit(
        "widgetContentLoaded",
        this.subscriber,
        this.addresses.list.length,
      )
    },
    addNewAddress() {
      this.editFlag = false
      this.showModal()
    },
    showModal() {
      this.modalVisibility = true
    },
    editAddress(address, index) {
      this.editFlag = true
      this.addressIndex = index
      this.newAddress = {
        id: address.id,
        email: address.email,
        street: address.street,
        phone: address.phone,
        city_id: address.city_id,
        primary: address.primary,
      }
      this.showModal()
    },
    saveAddress() {
      if (this.validateNewAddress()) {
        this.modalVisibility = false

        if (this.editFlag) {
          this.addresses
            .updateAddress({
              id: this.newAddress.id,
              email: this.newAddress.email,
              street: this.newAddress.street,
              phone: this.newAddress.phone,
              city_id: this.newAddress.city_id,
              is_primary: this.newAddress.primary,
            })
            .then((response) => {
              this.addresses.list = this.addresses.list.map(function (item) {
                if (response.data.data.is_primary === 1) {
                  item.primary = false
                }
                if (item.id === response.data.data.id) {
                  let updatedAddress = new Address()
                  return updatedAddress.fromJson(response.data.data)
                }
                return item
              })
            })
        } else {
          this.addresses.newAddress(this.newAddress).then((response) => {
            this.addresses.appendList(response.data.data)
          })
        }
        this.newAddress = { city_id: null }
      }
    },
    validatePhone(phone) {
      this.phone = phone
    },
    onPhoneInput(_, phone) {
      this.phone = phone
    },
    validateNewAddress() {
      if (!("city_id" in this.newAddress) || !this.newAddress.city_id) {
        this.$swal({
          type: "error",
          title: this.$tc("phrases.missingField"),
          text: "City is required",
        })
        return false
      } else if ("phone" in this.newAddress) {
        if (this.newAddress.phone.length === 0) {
          this.$swal({
            type: "error",
            title: this.$tc("phrases.missingField"),
            text: "Phone number is required",
          })
          return false
        }
        if (!this.newAddress.phone.startsWith("+")) {
          if (this.newAddress.phone.startsWith("00")) {
            this.newAddress.phone = this.newAddress.phone.replace("00", "+")
          } else {
            this.$swal({
              type: "error",
              title: this.$tc("phrases.missingField"),
              text: "Phone format is, +CountryCode Number (+255123123123) ",
            })
            return false
          }
        }
      }
      return true
    },
    closeModal() {
      this.modalVisibility = false
      this.newAddress = { city_id: null }
    },
    confirmDelete(address) {
      this.$swal({
        type: "warning",
        title: this.$tc("phrases.deleteAddress"),
        text: address.street,
        showCancelButton: true,
        cancelButtonText: this.$tc("words.cancel"),
        confirmButtonText: this.$tc("words.delete"),
      }).then(async (result) => {
        if (!result.value) return
        const response = await this.addresses.deleteAddress(address.id)
        if (response instanceof ErrorHandler) {
          this.alertNotify("error", response.errorMessage)
          return
        }
        this.addresses.list = this.addresses.list.filter(
          (item) => item.id !== address.id,
        )
        this.alertNotify("success", this.$tc("phrases.addressDeleted"))
      })
    },
  },
}
</script>

<style scoped lang="scss">
.address-edit-container {
  padding: 1rem;
}
.md-dialog-container {
  min-width: 240px !important;
}
</style>
